module.exports = __webpack_public_path__ + "24e004ab/img/archive-icon.0a6a9de3.svg";